import {NAVIGATION_CHANGE} from 'app/redux/constants/actionTypes';

const navigation = (payload) => {
  return {
    type: NAVIGATION_CHANGE,
    payload,
  }
};

export default navigation;